import * as React from 'react';
import Translator from '../Translator/Translator';
import util from '../../Util/util';
import * as moment from 'moment';

interface MaintenanceNotificationProps {
    maintenanceTime: moment.Moment
}

class MaintenanceNotificationBar extends React.Component<MaintenanceNotificationProps, {}> {
    public render() {
        return (
            <div className="maintenanceNotificationBar">
                <span>
                    <Translator path="enquiry.maintenance.first">Maintenance is scheduled on</Translator>
                    <span> {util.getMaintenanceDatetime(this.props.maintenanceTime)}</span>
                    <Translator path="enquiry.maintenance.second">.</Translator> </span>
                <span className="notificationContent">
                    <Translator path="enquiry.maintenance.last">Access to MIDAS will be temporarily unavailable. We apologize for any inconvenience caused.</Translator>
                </span>
            </div>
        );
    }
}

export default MaintenanceNotificationBar;



// WEBPACK FOOTER //
// ./src/Components/Maintenance/MaintenanceNotificationBar.tsx